import React from 'react';
import { notification } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import errorMessageHandler from '../handler/error-msg-handler';

/**
 * NMU-522: every notification card used to be white, with only the icon tinted
 * — so the outcome of an action was carried by a 20px glyph in the corner of
 * the screen. The card itself now carries the colour: green for a save, red for
 * a deletion or a failure, amber for a warning.
 *
 * The colour lives in CSS (styles/notification-cards.css), keyed by the class
 * added here. That is what makes it a system-wide standard rather than a Splash
 * Page one: every page in the admin already notifies through this module, so
 * there is exactly one place the palette is decided.
 */
const CLASS = {
    success: 'nmu-notify nmu-notify-success',
    error: 'nmu-notify nmu-notify-error',
    warning: 'nmu-notify nmu-notify-warning',
    info: 'nmu-notify nmu-notify-info',
    delete: 'nmu-notify nmu-notify-delete',
};

const info = (title, message) => {
    notification['info']({
        className: CLASS.info,
        message: title,
        description:
            message,
    });
}

const success = (title, message) => {
    notification['success']({
        className: CLASS.success,
        message: title,
        description:
            message,
    });
}

const error = (error) => {
    const { title, message } = errorMessageHandler.getMessage(error);
    notification['error']({
        className: CLASS.error,
        message: title,
        description:
            message,
    });
}

const warning = (title, message) => {
    notification['warning']({
        className: CLASS.warning,
        message: title,
        description:
            message,
    });
}

/**
 * A deletion that succeeded.
 *
 * NMU-522 asks for this one in red, which no antd type gives: `success` is
 * green and `error` would be a lie — nothing went wrong. So it is its own
 * kind, red like the row it just removed, with a bin rather than a tick.
 *
 * Use this instead of `success` whenever the thing that succeeded was a delete.
 */
const deleted = (title, message) => {
    notification.open({
        className: CLASS.delete,
        icon: <DeleteOutlined />,
        message: title,
        description:
            message,
    });
}

const notifyUtitls = {
    info,
    success,
    error,
    warning,
    deleted,
}

export default notifyUtitls;
